// extracted by mini-css-extract-plugin
export default {"collapse":"collapse--FfHwp","collapseContainer":"collapseContainer--W2jxv","collapseWrapperInner":"collapseWrapperInner--i4CGp","h100":"h100--tMwBz"};